import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import NutshellProPlan from './icon-nutshell-pro-plan.svg';

function SvgComponent() {
    return <NutshellProPlan height={30} width={50} />;
}

export const NutshellProPlanIcon = svgIconWrapper(SvgComponent);
